import React from 'react'

const FullWidthTabs = () => {
  return (
    <div>
      
    </div>
  )
}

export default FullWidthTabs
